import React from 'react';
import ThemeToggle from './ThemeToggle';
import './ThemeToggleButton.css';

const ThemeToggleButton = ({ theme, toggleTheme }) => (
  <div className="theme-toggle-fab">
    <ThemeToggle theme={theme} toggleTheme={toggleTheme} />
  </div>
);

export default ThemeToggleButton;
